<template>
  <v-row
    class="mx-5"
  >
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        label="Acervo"
        dense
        :items="tipos"
        :value="filter.idTipopublicacao"
        @input="onFilter({idTipopublicacao: $event}); onFilter({idTipoObjeto: null})"
        hide-details
        item-text="tipoPublicacao"
        item-value="idTipopublicacao"
        outlined
        clearable
        rounded
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        :items="segmentos"
        dense
        hide-details
        outlined
        clearable
        label="Área"
        item-text="segmento"
        item-value="id"
        rounded
        :value="filter.idSegmento"
        @input="onFilter({idSegmento: $event})"
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        :items="tiposObjetoFilter"
        dense
        hide-details
        outlined
        clearable
        :label="label"
        item-text="tipoObjeto"
        item-value="id"
        rounded
        :value="filter.idTipoObjeto"
        @input="onFilter({idTipoObjeto: $event})"
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="6"
      class="text-right"
    >
      <v-btn
        color="accent"
        rounded
        @click="generateReport(report)"
      >
        GERAR RELATÓRIO
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    onFilter: {
      type: Function,
      default: () => {},
    },
    generateReport: {
      type: Function,
      default: () => {},
    },
    report: {
      type: String,
      default: '',
    },
    tipoPublicacoes: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
    tiposObjeto: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    tipos() {
      if (this.tipoPublicacoes) {
        return this.tipoPublicacoes
          .filter(tp => tp.tipoPublicacao === 'Textual' || tp.tipoPublicacao === 'Peças');
      }
      return [];
    },
    tiposObjetoFilter() {
      if (this.tiposObjeto) {
        return this.tiposObjeto
          .filter((tp) => {
            if (this.filter && this.filter.idTipopublicacao) {
              return tp.idTipopublicacao === this.filter.idTipopublicacao;
            }
            return tp;
          });
      }
      return [];
    },
    label() {
      if (this.filter && this.filter.idTipopublicacao) {
        if (this.filter.idTipopublicacao === 40) {
          return 'Espécie Documental';
        }
        if (this.filter.idTipopublicacao === 57) {
          return 'Tipo de Objeto';
        }
      }
      return 'Espécie Documental/Tipo de Objeto';
    },
  },
};
</script>
